import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { useTranslate } from "react-admin";
import MemberDetailsModal from "./MemberDetailsModal";

const MemberDetailsButton = ({
    membre,
    component: Component = Button,
    children,
    sousCommanderie,
    className,
    ...props
}) => {
    const translate = useTranslate();
    const [open, setOpen] = useState(false);

    const membership = sousCommanderie
        ? membre.isInSousCommanderie(sousCommanderie["N° Sous-commanderie"])
        : null;

    let interim = "";
    if (membership?.interim) {
        interim = translate("Interim");
    }

    const handleClick = () => {
        if (!membership?.interim) {
            setOpen(!open);
        }
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <Component onClick={handleClick} className={className} {...props}>
                {children ? children : translate("Voir les coordonnées")}
            </Component>
            <MemberDetailsModal
                handleClose={handleClose}
                open={open}
                member={membre}
            />
        </>
    );
};

export default MemberDetailsButton;
